import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=0815ef98&scoped=true&lang=pug"
import script from "./ModelForm.vue?vue&type=script&lang=js"
export * from "./ModelForm.vue?vue&type=script&lang=js"
import style0 from "./ModelForm.vue?vue&type=style&index=0&id=0815ef98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815ef98",
  null
  
)

export default component.exports